import {css} from 'lit';
export const InputSharedStyles = css`:host {
    display: inline-block;
    box-sizing: border-box;
    position: relative;
    outline: none;
    padding: var(--keli-input-field-padding, 10px 0);
    -webkit-touch-callout: none;
    user-select: none;
    height: var(--keli-input-field-height, 40px);
    width: var(--keli-input-field-width);
    break-inside: avoid;
}

#input {
    box-sizing: border-box;
    font-weight: var(--keli-input-font-weight, 400);
    font-family: inherit;
    width: 100%;
    height: var(--keli-input-field-inner-height, 1.15em);
    padding: var(--keli-input-field-inner-padding, 0);
    color: var(--keli-input-field-text-color, var(--keli-text));
    background-color: var(--keli-input-field-background-color, var(--keli-field-background));
    border: none;
    min-height: var(--keli-input-field-min-height);
    text-align: var(--keli-input-field-text-align);
    font-size: var(--keli-input-field-font-size, .93em);
    letter-spacing: var(--keli-input-letter-spacing);
}

#input::placeholder {
    color: var(--keli-input-field-text-color, var(--keli-text-subtle));
    font-style: italic;
    font-weight: 300;
    font-size: .9em;
}

#input:focus {
    outline: none;
}

:host(.disabled) #input {
    background-color: var(--keli-input-field-background-color, var(--keli-field-disabled-background));
    cursor: not-allowed !important;
}

:host(.disabled) {
    cursor: not-allowed !important;
}

#shortcut {
    position: absolute;
    right: 0;
    top: 3em;
    font-size: .6em;
    color: var(--keli-text-subtle);
}`;

import {html} from '@polymer/polymer';
export const InputSharedStylesHTML = html`<style>:host {
    display: inline-block;
    box-sizing: border-box;
    position: relative;
    outline: none;
    padding: var(--keli-input-field-padding, 10px 0);
    -webkit-touch-callout: none;
    user-select: none;
    height: var(--keli-input-field-height, 40px);
    width: var(--keli-input-field-width);
    break-inside: avoid;
}

#input {
    box-sizing: border-box;
    font-weight: var(--keli-input-font-weight, 400);
    font-family: inherit;
    width: 100%;
    height: var(--keli-input-field-inner-height, 1.15em);
    padding: var(--keli-input-field-inner-padding, 0);
    color: var(--keli-input-field-text-color, var(--keli-text));
    background-color: var(--keli-input-field-background-color, var(--keli-field-background));
    border: none;
    min-height: var(--keli-input-field-min-height);
    text-align: var(--keli-input-field-text-align);
    font-size: var(--keli-input-field-font-size, .93em);
    letter-spacing: var(--keli-input-letter-spacing);
}

#input::placeholder {
    color: var(--keli-input-field-text-color, var(--keli-text-subtle));
    font-style: italic;
    font-weight: 300;
    font-size: .9em;
}

#input:focus {
    outline: none;
}

:host(.disabled) #input {
    background-color: var(--keli-input-field-background-color, var(--keli-field-disabled-background));
    cursor: not-allowed !important;
}

:host(.disabled) {
    cursor: not-allowed !important;
}

#shortcut {
    position: absolute;
    right: 0;
    top: 3em;
    font-size: .6em;
    color: var(--keli-text-subtle);
}</style>`;
